export const fmtSecs = (s) => {
  if (s == null || Number.isNaN(Number(s))) return null;
  const n = Number(s);
  if (n < 60) return `${n.toFixed(1)}s`;
  const m = Math.floor(n / 60);
  const rem = n - m * 60;
  return `${m}:${rem < 10 ? "0" : ""}${rem.toFixed(1)}`;
};

// True when this entry shares its score with another player but has a different time,
// i.e. the ranking between them was decided on time
export const isTimeTieBreak = (entries, entry) =>
  entries.some(
    (e) => e.participant_id !== entry.participant_id && e.score === entry.score && e.total_time !== entry.total_time
  );
